export default "__VITE_ASSET__BmLR0xM5__"